import { Button, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const RegisterMultiorgFormBottom = () => {
  const { authStore } = useEntitiesContext()
  const onClick = () => authStore.logout()

  return (
    <div className={styles.wrap}>
      <Typography variant={'body-sm-medium'} ariaLabel={'signInLink'}>
        Already have a Salesmsg account?
        <Button onClick={onClick} typeBtn={'link'} text={'Sign in'} />
      </Typography>
    </div>
  )
}
